import React from 'react';
import {
   View,
   Image,
   Text,
   Dimensions,
   StyleSheet,
   TouchableOpacity,
   Platform,
} from 'react-native';
import {
   appBackgroundWhiteBG,
   DROPDOWN_HOVER_COLOR,
   ExternalRecords,
   FONT_FAMILY_SEMI_BOLD,
   gray,
   IBTRecords,
   isHoverEnabled,
   isWeb,
   PROFILE,
   ThirdPartyRecords,
   TrainingAllRecords,
   TrainingOJTRecords,
} from './utils';
import {useNavigation} from '@react-navigation/native';

const {width, height} = Dimensions.get('window');
const TextHover = props => {
   const [isHover, setHover] = React.useState(false);
   return (
      <Text
         onMouseEnter={() => {
            setHover(true);
         }}
         onMouseLeave={() => {
            setHover(false);
         }}
         style={[
            props.style,
            isHoverEnabled && isHover && {color: DROPDOWN_HOVER_COLOR},
         ]}>
         {props?.children}
      </Text>
   );
};
export const MyTrainingPopup = props => {
   const navigation = useNavigation();

   return (
      <View style={styles.container}>
         <Image
            style={[
               styles.anchorImageUpward,
               {...Platform.select({web: {width: 22, height: 15}})},
            ]}
            source={require('../assets/anchorUpward.png')}
         />
         <View style={styles.background}>
            {props.screen !== PROFILE && (
               <View>
                  <TouchableOpacity
                     onPress={() => {
                        props.dismissPopover();
                        props.filterMytrainingData(TrainingAllRecords);
                     }}>
                     <TextHover style={[styles.textStyle]}>
                        {'All Records'}
                     </TextHover>
                  </TouchableOpacity>
                  <View style={styles.borderStyle} />

                  <TouchableOpacity
                     onPress={() => {
                        props.dismissPopover();
                        props.filterMytrainingData(IBTRecords);
                     }}>
                     <TextHover
                        style={[
                           styles.textStyle,
                           {marginTop: props.screen !== PROFILE ? 16 : 0},
                        ]}>
                        {'NORCAT Records'}
                     </TextHover>
                  </TouchableOpacity>
                  <View style={styles.borderStyle} />
                  <TouchableOpacity
                     onPress={() => {
                        props.dismissPopover();
                        props.filterMytrainingData(ExternalRecords);
                     }}>
                     <TextHover style={[styles.textStyle, {marginTop: 16}]}>
                        {'External Records'}
                     </TextHover>
                  </TouchableOpacity>
                  <View style={styles.borderStyle} />
               </View>
            )}

            <TouchableOpacity
               onPress={() => {
                  props.dismissPopover();
                  props.filterMytrainingData(ThirdPartyRecords);
               }}>
               <TextHover
                  style={[
                     styles.textStyle,
                     {marginTop: props.screen !== PROFILE ? 16 : 0},
                  ]}>
                  {'Third Party Records'}
               </TextHover>
            </TouchableOpacity>
            <View style={styles.borderStyle} />

            <TouchableOpacity
               onPress={() => {
                  props.dismissPopover();
                  props.filterMytrainingData(TrainingOJTRecords);
               }}>
               <TextHover
                  style={[
                     styles.textStyle,
                     {marginTop: props.screen !== PROFILE ? 16 : 0},
                  ]}>
                  {'OJT Records'}
               </TextHover>
            </TouchableOpacity>
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {width: 200, zIndex: 1},
   anchorImage: {
      marginBottom: 0,
      justifyContent: 'center',
      alignSelf: 'center',
   },
   anchorImageUpward: {
      marginBottom: 0,
      justifyContent: 'center',
      marginStart: 16,
      width: 20,
      marginTop: isWeb ? 0 : height / 80,
      height: 13,
      tintColor: appBackgroundWhiteBG,
   },
   background: {
      backgroundColor: appBackgroundWhiteBG,
      borderRadius: 8,
      paddingVertical: 16,
      paddingStart: 16,
      paddingEnd: 16,
   },
   textStyle: {
      color: '#212121',
      fontSize: 14,
      fontWeight: '400',
      marginStart: 8,
      fontFamily: FONT_FAMILY_SEMI_BOLD,
   },
   borderStyle: {
      width: 150,
      height: 1,
      backgroundColor: gray,
      marginTop: 8,
   },
});
